import { create } from 'zustand';
import ServicePerfis from '@/services/ServicePerfis';
import { notify } from '@/stores/useToast';

type Perfil = any;
export interface Permissao {
  id: string;
  code: string;
  display_name?: string;
  group?: string;
}

interface State {
  lista: Perfil[];
  carregando: boolean;
  permissoes: Permissao[];
  permissoesCarregadas: boolean;
  buscar: () => Promise<void>;
  carregarPermissoes: () => Promise<void>;
  buscarPerfil: (id: string) => Promise<Perfil | null>;
  criar: (dados: Record<string, unknown>) => Promise<void>;
  atualizar: (id: string, dados: Record<string, unknown>) => Promise<void>;
  atribuirPermissoes: (id: string, permissionIds: string[]) => Promise<void>;
  excluir: (id: string) => Promise<void>;
}

export const usePerfisStore = create<State>((set, get) => ({
  lista: [],
  carregando: false,
  permissoes: [],
  permissoesCarregadas: false,

  async buscar() {
    set({ carregando: true });
    try {
      const { data } = await ServicePerfis.listar();
      set({ lista: Array.isArray(data) ? data : (data.content ?? []) });
    } catch {
      notify.error('Erro ao buscar perfis.');
    } finally {
      set({ carregando: false });
    }
  },

  async carregarPermissoes() {
    if (get().permissoesCarregadas) return;
    try {
      const { data } = await ServicePerfis.listarPermissoes();
      const raw: Permissao[] = Array.isArray(data) ? data : (data?.content ?? []);
      // Só permissões eGov (paridade com o legado StoreRoles.fetchPermissions).
      const list = raw.filter((p: Permissao) => p.code?.startsWith('egov:'));
      set({ permissoes: list, permissoesCarregadas: true });
    } catch {
      notify.error('Erro ao carregar catálogo de permissões.');
    }
  },

  async buscarPerfil(id) {
    try {
      const { data } = await ServicePerfis.buscar(id);
      return data;
    } catch {
      notify.error('Erro ao carregar perfil.');
      return null;
    }
  },

  async criar(dados) {
    await ServicePerfis.criar(dados);
    await get().buscar();
  },

  async atualizar(id, dados) {
    await ServicePerfis.atualizar(id, dados);
    await get().buscar();
  },

  async atribuirPermissoes(id, permissionIds) {
    await ServicePerfis.atribuirPermissoes(id, permissionIds);
  },

  async excluir(id) {
    try {
      await ServicePerfis.excluir(id);
      notify.success('Perfil excluído.');
      await get().buscar();
    } catch {
      notify.error('Erro ao excluir perfil.');
    }
  },
}));
